import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { Action } from './action'

@Injectable({
  providedIn: 'root',
})
export class ActionService extends RestClientPaged<Action, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/actions', http, {
      idField: 'id',
    })
  }
}
